import { jsxs, jsx } from "react/jsx-runtime";
import TrendingUp from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/trending-up.js";
import TrendingDown from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/trending-down.js";
import ArrowRight from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/arrow-right.js";
function ScoreSummaryCards({ summary }) {
  const isImproved = summary.improvement > 0;
  const improvementColor = isImproved ? "text-green-600" : summary.improvement < 0 ? "text-red-600" : "text-gray-600";
  const improvementBg = isImproved ? "bg-green-50 border-green-200" : summary.improvement < 0 ? "bg-red-50 border-red-200" : "bg-gray-50 border-gray-200";
  return /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "p-6 bg-white rounded-xl border border-blue-200 shadow-2xs", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
        /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-8 h-8 bg-blue-100 rounded-lg", children: /* @__PURE__ */ jsx("span", { className: "text-sm font-bold text-blue-600", children: "Pre" }) }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-gray-500", children: "Pre-AIQ" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "text-3xl font-bold text-blue-600", children: [
        summary.preScore,
        /* @__PURE__ */ jsx("span", { className: "text-lg text-gray-400", children: "점" })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "mt-1 text-sm text-gray-500", children: [
        summary.preCorrectCount,
        "/",
        summary.totalQuestions,
        "문제 정답"
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "p-6 bg-white rounded-xl border border-purple-200 shadow-2xs", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
        /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-8 h-8 bg-purple-100 rounded-lg", children: /* @__PURE__ */ jsx("span", { className: "text-sm font-bold text-purple-600", children: "Post" }) }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-gray-500", children: "Post-AIQ" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "text-3xl font-bold text-purple-600", children: [
        summary.postScore,
        /* @__PURE__ */ jsx("span", { className: "text-lg text-gray-400", children: "점" })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "mt-1 text-sm text-gray-500", children: [
        summary.postCorrectCount,
        "/",
        summary.totalQuestions,
        "문제 정답"
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `p-6 rounded-xl border shadow-2xs ${improvementBg}`, children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
        /* @__PURE__ */ jsx("div", { className: `flex items-center justify-center w-8 h-8 rounded-lg ${isImproved ? "bg-green-100" : "bg-gray-100"}`, children: isImproved ? /* @__PURE__ */ jsx(TrendingUp, { className: "w-4 h-4 text-green-600" }) : summary.improvement < 0 ? /* @__PURE__ */ jsx(TrendingDown, { className: "w-4 h-4 text-red-600" }) : /* @__PURE__ */ jsx(ArrowRight, { className: "w-4 h-4 text-gray-500" }) }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-gray-500", children: "성장" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: `text-3xl font-bold ${improvementColor}`, children: [
        summary.improvement > 0 ? "+" : "",
        summary.improvement,
        /* @__PURE__ */ jsx("span", { className: "text-lg text-gray-400", children: "점" })
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "mt-1 text-sm text-gray-500", children: [
        summary.improvementPercent > 0 ? "+" : "",
        summary.improvementPercent.toFixed(1),
        "% 변화"
      ] })
    ] })
  ] });
}
export {
  ScoreSummaryCards
};
//# sourceMappingURL=ScoreSummaryCards.js.map
